// extracted by mini-css-extract-plugin
export default {"customerList":"customers_customerList__hGNP-","customerItem":"customers_customerItem__RI3yP"};